(function () {
  function initHeyTaosNavigation() {
    if (document.documentElement.dataset.heyTaosNavigationReady === 'true') return;
    document.documentElement.dataset.heyTaosNavigationReady = 'true';

    var desktopNav = document.querySelector('[data-ht-desktop-nav]');
    var desktopTriggers = desktopNav
      ? Array.prototype.slice.call(desktopNav.querySelectorAll('[data-ht-desktop-trigger]'))
      : [];
    var desktopPanels = desktopNav
      ? Array.prototype.slice.call(desktopNav.querySelectorAll('[data-ht-desktop-panel]'))
      : [];
    var primaryControls = desktopNav
      ? Array.prototype.slice.call(desktopNav.querySelectorAll('[data-ht-primary-control]'))
      : [];
    var activeDesktopTrigger = null;
    var hoverOpenTimer = null;
    var hoverCloseTimer = null;
    var desktopHoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

    function clearDesktopHoverTimers() {
      if (hoverOpenTimer) {
        window.clearTimeout(hoverOpenTimer);
        hoverOpenTimer = null;
      }
      if (hoverCloseTimer) {
        window.clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      }
    }

    function cancelDesktopOpen() {
      if (!hoverOpenTimer) return;
      window.clearTimeout(hoverOpenTimer);
      hoverOpenTimer = null;
    }

    function cancelDesktopClose() {
      if (!hoverCloseTimer) return;
      window.clearTimeout(hoverCloseTimer);
      hoverCloseTimer = null;
    }

    function scheduleDesktopOpen(trigger) {
      if (!desktopHoverCapable.matches || !trigger) return;
      if (activeDesktopTrigger === trigger && trigger.getAttribute('aria-expanded') === 'true') {
        cancelDesktopClose();
        return;
      }

      cancelDesktopOpen();
      cancelDesktopClose();

      var delay = activeDesktopTrigger ? 90 : 225;
      hoverOpenTimer = window.setTimeout(function () {
        hoverOpenTimer = null;
        openDesktopNavigation(trigger);
      }, delay);
    }

    function scheduleDesktopClose(delay) {
      if (!desktopHoverCapable.matches || !activeDesktopTrigger) return;
      cancelDesktopOpen();
      cancelDesktopClose();
      hoverCloseTimer = window.setTimeout(function () {
        hoverCloseTimer = null;
        closeDesktopNavigation(false);
      }, typeof delay === 'number' ? delay : 260);
    }

    function warmDesktopPanelVisual(trigger) {
      if (!desktopNav || !trigger) return;
      var key = trigger.getAttribute('data-ht-desktop-trigger');
      var panel = desktopNav.querySelector('[data-ht-desktop-panel="' + key + '"]');
      var image = panel ? panel.querySelector('[data-ht-feature-image]') : null;
      if (!image || image.dataset.htWarm === 'true') return;

      image.dataset.htWarm = 'true';
      image.loading = 'eager';
      image.fetchPriority = 'high';
      if (typeof image.decode === 'function') {
        image.decode().catch(function () {});
      }
    }

    function closeDesktopNavigation(restoreFocus) {
      clearDesktopHoverTimers();
      desktopTriggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      desktopPanels.forEach(function (panel) {
        panel.hidden = true;
      });

      if (restoreFocus && activeDesktopTrigger) activeDesktopTrigger.focus();
      activeDesktopTrigger = null;
    }

    function openDesktopNavigation(trigger) {
      if (!desktopNav || !trigger) return;
      var key = trigger.getAttribute('data-ht-desktop-trigger');
      var panel = desktopNav.querySelector('[data-ht-desktop-panel="' + key + '"]');
      var alreadyOpen =
        activeDesktopTrigger === trigger &&
        trigger.getAttribute('aria-expanded') === 'true' &&
        panel &&
        panel.hidden === false;

      warmDesktopPanelVisual(trigger);
      cancelDesktopOpen();
      cancelDesktopClose();

      if (alreadyOpen) return;
      if (!panel) return;

      desktopTriggers.forEach(function (otherTrigger) {
        otherTrigger.setAttribute('aria-expanded', otherTrigger === trigger ? 'true' : 'false');
      });
      desktopPanels.forEach(function (otherPanel) {
        otherPanel.hidden = otherPanel !== panel;
      });

      activeDesktopTrigger = trigger;
    }

    desktopTriggers.forEach(function (trigger) {
      trigger.addEventListener('pointerenter', function () {
        warmDesktopPanelVisual(trigger);
        scheduleDesktopOpen(trigger);
      });
      trigger.addEventListener('pointerleave', cancelDesktopOpen);
      trigger.addEventListener('focus', function () {
        warmDesktopPanelVisual(trigger);
      });
      trigger.addEventListener('click', function () {
        clearDesktopHoverTimers();
        openDesktopNavigation(trigger);
      });
    });

    if (desktopNav) {
      desktopNav.addEventListener('pointerenter', cancelDesktopClose);
      desktopNav.addEventListener('pointerleave', function () {
        scheduleDesktopClose(260);
      });

      Array.prototype.slice.call(desktopNav.querySelectorAll('[data-ht-primary-control]:not([data-ht-desktop-trigger]), .ht-nav__search')).forEach(function (control) {
        control.addEventListener('pointerenter', function () {
          scheduleDesktopClose(120);
        });
      });
    }

    desktopPanels.forEach(function (panel) {
      var closeButton = panel.querySelector('[data-ht-desktop-close]');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          closeDesktopNavigation(true);
        });
      }
    });

    primaryControls.forEach(function (control, index) {
      control.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var offset = event.key === 'ArrowRight' ? 1 : -1;
        var nextIndex = (index + offset + primaryControls.length) % primaryControls.length;
        primaryControls[nextIndex].focus();
      });
    });

    document.addEventListener('pointerdown', function (event) {
      if (!activeDesktopTrigger || !desktopNav || desktopNav.contains(event.target)) return;
      closeDesktopNavigation(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activeDesktopTrigger) {
        event.preventDefault();
        closeDesktopNavigation(true);
      }
    });

    var mobileTrigger = document.querySelector('[data-ht-mobile-open]');
    var mobileDrawer = document.querySelector('[data-ht-mobile-drawer]');
    var mobileCloseControls = mobileDrawer
      ? Array.prototype.slice.call(mobileDrawer.querySelectorAll('[data-ht-mobile-close]'))
      : [];

    function mobileFocusable() {
      if (!mobileDrawer) return [];
      return Array.prototype.slice.call(
        mobileDrawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    function openMobileNavigation() {
      if (!mobileTrigger || !mobileDrawer) return;
      mobileDrawer.hidden = false;
      mobileDrawer.setAttribute('aria-hidden', 'false');
      mobileTrigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ht-mobile-nav-open');
      var closeButton = mobileDrawer.querySelector('.ht-mobile-drawer__close');
      window.requestAnimationFrame(function () {
        var drawerTitle = mobileDrawer.querySelector('.ht-mobile-drawer__header h2');
        if (drawerTitle) { drawerTitle.focus({ preventScroll: true }); } else if (closeButton) { closeButton.focus(); }
      });
    }

    function closeMobileNavigation(restoreFocus) {
      if (!mobileTrigger || !mobileDrawer || mobileDrawer.hidden) return;

      Array.prototype.slice.call(mobileDrawer.querySelectorAll('[data-ht-mobile-section]')).forEach(function (section) {
        section.open = false;
      });

      var mobilePanel = mobileDrawer.querySelector('.ht-mobile-drawer__panel');
      if (mobilePanel) mobilePanel.scrollTop = 0;

      mobileDrawer.hidden = true;
      mobileDrawer.setAttribute('aria-hidden', 'true');
      mobileTrigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ht-mobile-nav-open');
      if (restoreFocus) mobileTrigger.focus();
    }

    if (mobileTrigger) mobileTrigger.addEventListener('click', openMobileNavigation);
    mobileCloseControls.forEach(function (control) {
      control.addEventListener('click', function () {
        closeMobileNavigation(true);
      });
    });

    if (mobileDrawer) {
      Array.prototype.slice.call(mobileDrawer.querySelectorAll('[data-ht-mobile-section]')).forEach(function (section) {
        section.addEventListener('toggle', function () {
          if (!section.open) return;

          Array.prototype.slice.call(mobileDrawer.querySelectorAll('[data-ht-mobile-section]')).forEach(function (other) {
            if (other !== section) other.open = false;
          });

          window.requestAnimationFrame(function () {
            var panel = mobileDrawer.querySelector('.ht-mobile-drawer__panel');
            var summary = section.querySelector('summary');
            var stickyHeader = mobileDrawer.querySelector('.ht-mobile-drawer__header');
            if (!panel || !summary) return;

            var panelRect = panel.getBoundingClientRect();
            var summaryRect = summary.getBoundingClientRect();
            var stickyHeight = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
            var targetTop = Math.max(0, panel.scrollTop + summaryRect.top - panelRect.top - stickyHeight - 12);

            if (Math.abs(panel.scrollTop - targetTop) > 16) {
              panel.scrollTo({
                top: targetTop,
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
              });
            }
          });
        });
      });

      mobileDrawer.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeMobileNavigation(true);
          return;
        }

        if (event.key !== 'Tab') return;
        var focusable = mobileFocusable();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 1100px)').matches) {
        closeMobileNavigation(false);
      } else {
        closeDesktopNavigation(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeyTaosNavigation, { once: true });
  } else {
    initHeyTaosNavigation();
  }
})();

/* HEYTAOS DESKTOP PRIMARY NAV MOTION — 2026-09-22 START */
(function () {
  function initHeyTaosDesktopPrimaryMotion() {
    if (document.documentElement.dataset.heyTaosDesktopPrimaryMotionReady === 'true') return;

    var media = window.matchMedia('(min-width: 1100px)');
    var nav = document.querySelector('[data-ht-desktop-nav]');
    if (!nav) return;

    var items = nav.querySelector('.ht-nav__items');
    if (!items) return;

    var controls = Array.prototype.slice.call(items.querySelectorAll('.ht-nav__control'));
    if (!controls.length) return;

    document.documentElement.dataset.heyTaosDesktopPrimaryMotionReady = 'true';

    function baseTarget() {
      return controls.find(function (control) {
        return control.getAttribute('aria-expanded') === 'true';
      }) || controls.find(function (control) {
        return control.classList.contains('is-active') || control.getAttribute('aria-current') === 'page';
      }) || null;
    }

    function clearTargetClasses() {
      controls.forEach(function (control) {
        control.classList.remove('ht-nav__motion-target');
      });
    }

    function placeIndicator(control) {
      if (!media.matches || !control) {
        clearTargetClasses();
        items.classList.remove('has-ht-motion-indicator');
        return;
      }

      var itemsRect = items.getBoundingClientRect();
      var controlRect = control.getBoundingClientRect();
      var inset = Math.min(18, Math.max(10, controlRect.width * 0.11));
      var x = controlRect.left - itemsRect.left + inset;
      var width = Math.max(28, controlRect.width - inset * 2);

      items.style.setProperty('--ht-nav-indicator-x', x.toFixed(2) + 'px');
      items.style.setProperty('--ht-nav-indicator-width', width.toFixed(2) + 'px');

      clearTargetClasses();
      control.classList.add('ht-nav__motion-target');
      items.classList.add('has-ht-motion-indicator');
    }

    function restoreBaseTarget() {
      var target = baseTarget();
      items.classList.remove('is-ht-motion-interacting');
      if (target) {
        placeIndicator(target);
      } else {
        clearTargetClasses();
        items.classList.remove('has-ht-motion-indicator');
      }
    }

    controls.forEach(function (control) {
      control.addEventListener('pointerenter', function () {
        if (!media.matches) return;
        items.classList.add('is-ht-motion-interacting');
        placeIndicator(control);
      });

      control.addEventListener('focus', function () {
        if (!media.matches) return;
        items.classList.add('is-ht-motion-interacting');
        placeIndicator(control);
      });
    });

    nav.addEventListener('pointerleave', function () {
      if (!media.matches) return;
      window.requestAnimationFrame(restoreBaseTarget);
    });

    nav.addEventListener('focusout', function (event) {
      if (!media.matches) return;
      if (event.relatedTarget && nav.contains(event.relatedTarget)) return;
      window.requestAnimationFrame(restoreBaseTarget);
    });

    var observer = new MutationObserver(function () {
      if (!media.matches) return;
      var openTarget = controls.find(function (control) {
        return control.getAttribute('aria-expanded') === 'true';
      });
      if (openTarget) placeIndicator(openTarget);
    });

    controls.forEach(function (control) {
      observer.observe(control, {
        attributes: true,
        attributeFilter: ['aria-expanded', 'aria-current']
      });
    });

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(function () {
        if (!media.matches) {
          clearTargetClasses();
          items.classList.remove('has-ht-motion-indicator', 'is-ht-motion-interacting');
          return;
        }

        var target = items.querySelector('.ht-nav__motion-target') || baseTarget();
        if (target) placeIndicator(target);
      });
    });

    restoreBaseTarget();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeyTaosDesktopPrimaryMotion, { once: true });
  } else {
    initHeyTaosDesktopPrimaryMotion();
  }
})();
/* HEYTAOS DESKTOP PRIMARY NAV MOTION — 2026-09-22 END */
